/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircleNumber7 = createReactComponent("outline", "circle-number-7", "IconCircleNumber7", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8h4l-2 8", "key": "svg-1" }]]);

export { IconCircleNumber7 as default };
//# sourceMappingURL=IconCircleNumber7.mjs.map
